import { lazyLoad } from 'utils/loadable';

export const UserDetailPage = lazyLoad(
  () => import('./index'),
  module => module.UserDetailPage,
);
